import Button from 'components/Button';
import FeaturedIcon from 'components/FeaturedIcon';
import DownloadIcon from 'components/icons/Download';
import SearchIcon from 'components/icons/Search';
import { FC, useState } from 'react';
import styled from 'styled-components';
import DocumentationFile from 'types/DocumentationFile';
import downloadFile from 'utils/downloadFile';
import DocumentComponent from './DocumentContainer';

const EmptyContainer = styled.div`
  margin-top: 4rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-weight: 500;
  color: var(--gray-900);
`;

const DownloadAllContainer = styled.div`
  button {
    margin-left: auto;
    margin-right: 0;
  }
  margin-bottom: 1rem;
  width: 100%;
`;

type Props = {
  documents: DocumentationFile[];
  downloadUrl: string;
  emptyText: string;
};
const DocumentList: FC<Props> = ({ documents, downloadUrl, emptyText }) => {
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<boolean>(false);
  const handleDownload = () => {
    setLoading(true);
    Promise.all(
      documents.map((document) =>
        downloadFile(
          `${downloadUrl}/${document.id}`,
          document.filename || 'fichier',
        ),
      ),
    )
      .catch(() => {
        setError(true);
        setTimeout(() => setError(false), 1000);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return documents.length ? (
    <>
      <DownloadAllContainer>
        <Button
          color={error ? 'error' : 'primary'}
          variant={error ? 'soft-outlined' : 'filled'}
          type="button"
          icon={<DownloadIcon />}
          onClick={handleDownload}
          loading={loading}
        >
          {error ? 'Erreur' : 'Tout télécharger'}
        </Button>
      </DownloadAllContainer>
      {documents.map((document, idx) => (
        <DocumentComponent
          document={document}
          key={idx}
          downloadUrl={downloadUrl}
        />
      ))}
    </>
  ) : (
    <EmptyContainer>
      <FeaturedIcon icon={<SearchIcon />} />
      <p>{emptyText}</p>
    </EmptyContainer>
  );
};

export default DocumentList;
